import React from 'react'

export default function Footer() {
  return (
    <>
        {/* SVG Wave Transition to Next Section */}
        <svg 
            className="w-full h-auto"
            xmlns="http://www.w3.org/2000/svg"  
            viewBox="0 0 1440 320">
        <path 
            fill="#27272a" 
            fill-opacity="1" 
            d="M0,96L60,85.3C120,75,240,53,360,80C480,107,600,181,720,224C840,267,960,277,1080,250.7C1200,224,1320,160,1380,128L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z">
        </path>
        </svg>
        <div className="flex items-center justify-evenly p-[200px] sm:p-[60px] md:p-[100px] lg:p-[210px] max-md:p-[30px]">
            <footer className=" flex-col bg-zinc-900 ">
              <div className="flex justify-between items-center p-7">

              <h1 className="text-3xl md:text-2xl lg:text-3xl max-md:text-3xl flex items-center text-white font-extrabold">
                Jobbie
              </h1>

                <div className="flex justify-between  ">
                  <a
                    href="#comment"
                    className=" m-4 hover:text-white text-gray-400 hover:underline max-md:text-[10px] "
                  >
                    License
                  </a>
                  <a
                    href="#comment"
                    className=" m-4 hover:text-white text-gray-400 hover:underline max-md:text-[10px] "
                  >
                    Privacy and Policy
                  </a>
                  <a
                    href="#comment"
                    className=" m-4 hover:text-white text-gray-400 hover:underline max-md:text-[10px] "
                  >
                    Faqs
                  </a>
                </div>

              </div>
            <p href="" className=" text-gray-400 text-center ">
              &copy; copyright Jobbie 2025
            </p>
         </footer>
        </div>
    </>
  )            
}


